var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-advance-select", {
    staticStyle: { width: "100%" },
    attrs: {
      disabled: _vm.disabled,
      "select-type": _vm.selectTypeNames.basic_data_Packing,
      "show-custom-label-in-option": true,
      "custom-label": _vm.packingLabel,
      filterable: "",
      "default-value": _vm.defaultValue,
      placeholder: _vm.placeholder || undefined
    },
    on: {
      clear: function($event) {
        return _vm.$emit("clear")
      },
      parentCallBack: function(p) {
        _vm.$emit("change", p)
      },
      blur: function($event) {
        return _vm.$emit("blur")
      },
      focus: function($event) {
        return _vm.$emit("focus")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }